/* eslint-disable max-len */
export const ToDoIcon = () => {
  return (
    <svg
      width="53"
      height="49"
      viewBox="0 0 53 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M5.2168 3.72754C3.2838 3.72754 1.7168 5.29455 1.7168 7.22754V42.8255C1.7168 44.7585 3.2838 46.3255 5.2168 46.3255H35.4783C37.4113 46.3255 38.9783 44.7585 38.9783 42.8255V7.22754C38.9783 5.29454 37.4113 3.72754 35.4783 3.72754H5.2168Z"
        fill="#C1E6FE"
        stroke="white"
        strokeWidth="3"
      />
      <rect
        x="7.7959"
        y="13.4773"
        width="22.0253"
        height="3.29983"
        fill="#043C32"
      />
      <rect
        x="7.7959"
        y="22.552"
        width="13.052"
        height="3.29983"
        fill="#043C32"
      />
      <rect
        x="7.7959"
        y="31.626"
        width="13.052"
        height="3.29983"
        fill="#043C32"
      />
      <path
        d="M46.3076 9.61077L46.3076 9.61076L42.1097 8.29843L42.8382 6.98719C42.8374 6.98674 42.8366 6.98629 42.8358 6.98584C41.8668 6.44896 40.6605 6.62696 39.8818 7.40572L40.9424 8.46638L39.8818 7.40572L37.8075 9.47999C37.4078 9.87968 37.2667 10.4701 37.4426 11.0073C37.6073 11.5105 38.0239 11.887 38.5352 12.0032C39.6616 12.6449 40.6876 13.4233 41.5865 14.3222C42.4901 15.2258 43.2748 16.2526 43.9052 17.3723C44.0252 17.9015 44.422 18.3252 44.9433 18.4792C45.4703 18.6348 46.0402 18.4898 46.4288 18.1012L48.503 16.027C49.3025 15.2275 49.4278 14.0398 48.9402 13.1052C48.9343 13.0938 48.9282 13.0826 48.922 13.0714C48.2118 11.791 47.32 10.6324 46.3076 9.61077Z"
        fill="#FFADBF"
        stroke="white"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M39.9333 9.34727L39.9153 9.33739C39.6296 9.18356 39.3582 9.11418 39.2055 9.07894C38.7015 8.96265 38.1732 9.11416 37.8075 9.47987L35.3973 11.89C34.9977 12.2897 34.8566 12.8802 35.0325 13.4174C35.1972 13.9206 35.6138 14.297 36.125 14.4133C37.2514 15.055 38.2775 15.8334 39.1764 16.7323C40.08 17.6359 40.8646 18.6626 41.4951 19.7823C41.615 20.3115 42.0118 20.7353 42.5331 20.8892C43.0601 21.0449 43.63 20.8999 44.0186 20.5113L46.4288 18.1011C46.7886 17.7413 46.9414 17.2237 46.8348 16.7262C46.7915 16.5241 46.7191 16.268 46.5713 15.9934L46.5577 15.9687C45.7789 14.5853 44.8235 13.3164 43.7079 12.2008C42.5957 11.0886 41.3258 10.1219 39.9333 9.34727Z"
        fill="#043C32"
        stroke="white"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M31.7699 24.173C32.6732 25.0762 33.4576 26.1026 34.0879 27.2218C34.2131 27.7224 34.5885 28.127 35.0853 28.2862C35.6204 28.4577 36.2064 28.3157 36.6038 27.9184L44.0107 20.5115C44.3704 20.1517 44.5233 19.6341 44.4167 19.1366C44.3734 18.9344 44.301 18.6784 44.1531 18.4038L44.1396 18.3791C43.3849 17.0385 42.4644 15.8055 41.3929 14.7152C41.3632 14.6793 41.3316 14.6446 41.2981 14.6112C40.186 13.499 38.9161 12.5323 37.5236 11.7577L37.5055 11.7478C37.2198 11.594 36.9484 11.5246 36.7957 11.4893C36.2918 11.373 35.7635 11.5246 35.3978 11.8903L27.9657 19.3224C27.5622 19.7259 27.4226 20.3235 27.6056 20.864C27.7773 21.3714 28.2053 21.746 28.725 21.8524C29.8428 22.4815 30.863 23.266 31.7699 24.173Z"
        fill="#FC7D43"
        stroke="white"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M33.8993 22.0515C32.7885 20.9407 31.5212 19.9758 30.1412 19.2025C29.8588 19.0423 29.5502 18.9383 29.2326 18.896C28.7627 18.8333 28.2909 18.9965 27.9601 19.336C27.5048 19.8033 27.1487 20.3514 26.9137 20.9655L25.1702 25.3831C24.9183 26.0212 25.1314 26.7488 25.6878 27.1502C26.2863 27.5821 26.8435 28.0569 27.353 28.5739L28.4214 27.521L27.353 28.5739C27.8817 29.1103 28.3407 29.639 28.7565 30.2181C29.157 30.776 29.8852 30.9906 30.5243 30.7391L34.9366 29.0027C35.5673 28.7592 36.1293 28.3923 36.6034 27.9182C36.9459 27.5757 37.102 27.0888 37.0223 26.611C36.9718 26.3077 36.8606 26.0391 36.7504 25.8369L36.7504 25.8369L36.7444 25.826C35.9938 24.4767 35.0628 23.2425 33.9939 22.1554C33.9642 22.1195 33.9327 22.0848 33.8993 22.0515Z"
        fill="#F2B888"
        stroke="white"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M25.17 25.3834L23.7779 28.9141C23.3668 29.9397 23.7133 30.9553 24.3291 31.5711L25.3898 30.5104L24.3291 31.5711C24.9448 32.1867 25.9601 32.5332 26.9854 32.1226L30.5241 30.7306C30.9561 30.5606 31.2852 30.2002 31.4151 29.7545C31.545 29.3087 31.4612 28.8279 31.1881 28.4525C30.6695 27.7395 30.0994 27.0783 29.4899 26.4596C29.4541 26.4233 29.4167 26.389 29.378 26.3569C28.772 25.7614 28.1344 25.2246 27.4532 24.7245C27.0781 24.4491 26.5966 24.3634 26.1496 24.4924C25.7025 24.6214 25.3407 24.9505 25.17 25.3834Z"
        fill="#043C32"
        stroke="white"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M45.2421 10.6666C44.3184 9.74285 43.2686 8.93666 42.1097 8.29843C41.7318 8.08848 41.2532 8.15566 40.9424 8.46638L38.8682 10.5406C38.9773 10.5574 39.0949 10.5994 39.2041 10.6582C40.4722 11.372 41.6311 12.2454 42.6472 13.2616C43.6633 14.2777 44.5451 15.4366 45.2505 16.7047C45.3093 16.8138 45.3429 16.923 45.3681 17.0406L47.4424 14.9663C47.7531 14.6556 47.8119 14.1853 47.6103 13.799C46.9721 12.6485 46.1659 11.5988 45.2421 10.6666Z"
        fill="#FFADBF"
      />
      <path
        d="M42.6472 13.2614C41.6311 12.2453 40.4722 11.3635 39.2041 10.6581C39.0949 10.5993 38.9774 10.5657 38.8682 10.5405L36.458 12.9507C36.5672 12.9675 36.6848 13.0095 36.7939 13.0683C38.062 13.7821 39.2209 14.6555 40.237 15.6716C41.2532 16.6877 42.135 17.8467 42.8404 19.1147C42.8992 19.2239 42.9327 19.3331 42.9579 19.4506L45.3681 17.0405C45.3429 16.9229 45.3093 16.8137 45.2506 16.7045C44.5367 15.4365 43.6634 14.2776 42.6472 13.2614Z"
        fill="#043C32"
      />
      <path
        d="M40.2375 15.6718C39.2213 14.6557 38.0624 13.7739 36.7944 13.0685C36.6852 13.0097 36.5676 12.9761 36.4585 12.9509L29.0264 20.383C29.1523 20.3998 29.2783 20.4418 29.3959 20.509C30.6639 21.2144 31.8145 22.0962 32.8306 23.1123C33.8467 24.1285 34.7285 25.2874 35.4339 26.5554C35.4843 26.6478 35.5263 26.757 35.5431 26.8578L42.95 19.4509C42.9248 19.3333 42.8912 19.2241 42.8324 19.1149C42.1186 17.8469 41.2452 16.688 40.2291 15.6718H40.2375Z"
        fill="#FC7D43"
      />
      <path
        d="M32.8386 23.1121C31.8225 22.096 30.6636 21.2142 29.4039 20.5088C29.2863 20.4416 29.1604 20.3996 29.0344 20.3828C28.7153 20.7103 28.4717 21.0882 28.3122 21.5081L26.5654 25.9338C27.2289 26.4125 27.8503 26.9415 28.4214 27.521C28.9924 28.1004 29.5047 28.6883 29.975 29.3433L34.3922 27.605C34.8289 27.437 35.2152 27.1851 35.5427 26.8576C35.5259 26.7568 35.4839 26.6476 35.4336 26.5552C34.7281 25.2872 33.8464 24.1283 32.8302 23.1121H32.8386Z"
        fill="#F2B888"
      />
      <path
        d="M28.4214 27.5208C27.8419 26.9413 27.2289 26.4207 26.5655 25.9336L25.1714 29.4691C25.0119 29.8638 25.1378 30.2585 25.3898 30.5104C25.6417 30.7624 26.0364 30.8883 26.4311 30.7288L29.975 29.3347C29.5047 28.6881 28.984 28.0834 28.4214 27.5124V27.5208Z"
        fill="#043C32"
      />
    </svg>
  );
};
